/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/crown': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2.165 8.72a1 1 0 011.516-.937l2.595 1.58a1 1 0 001.278-.2l3.688-4.283a1 1 0 011.516 0l3.688 4.282a1 1 0 001.278.202l2.595-1.58a1 1 0 011.516.937l-.87 10.363a1 1 0 01-.996.916H4.031a1 1 0 01-.997-.916L2.164 8.72z" _stroke="currentColor" stroke-width="2"/>'
  }
})
